import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'

export default function Services() {
  useEffect(() => {
    Aos.init({
        duration: 1000
    })

}, [])
  return<>
  
<div className="container-fluid bg-primary py-5 bg-hero mb-5">
  <div className="container py-5">
    <div className="row justify-content-start">
      <div className="col-lg-8 text-center text-lg-start">
        <h1 className="display-1 text-white mb-md-4">Our Story</h1>
        <Link to="/" className="btn btn-primary py-md-3 px-md-5 me-3">Home</Link>
        <Link  className="btn btn-secondary py-md-3 px-md-5">Our Story</Link>
      </div>
    </div>
  </div>
</div>

      {/* Services Start */}
      <div className="container-fluid py-5">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-4 col-md-6">
                        <div className="mt-5" data-aos="fade-right" data-aos-delay="200">
                            <h6 className="text-primary text-uppercase">Our Story</h6>
                            <h1 className="display-5">Elshebany Farms Story</h1>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>journey</h4>
                            <p className="mb-0">Our journey began as farmers with years of experience, cultivating our own
                                vegetable and fruit farms. Over time, we have continuously enhanced our production
                                using the latest modern techniques, all while avoiding the use of pesticides, making
                                our produce ideal for export to Europe, the US, and beyond.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>currently</h4>
                            <p className="mb-0">We are currently considering establishing our own packing facility in the near future,
                                along with a factory for concentrated juices. The exceptional quality of our farm
                                products has attracted exporting companies, which purchase and distribute our crops
                                globally</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>inspiration</h4>
                            <p className="mb-0">This inspired us to launch ElShaibany Company, dedicated to exporting our highquality farm produce worldwide. We have partnered with state-of-the-art sorting and
                                packing stations that are fully certified and equipped with a skilled workforce</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>vision</h4>
                            <p className="mb-0">Our vision is to expand into key global markets, opening offices in countries that
                                import from Egypt. This demonstrates our commitment to global growth by
                                regularly participating in international exhibitions. Additionally, we are exploring
                                partnerships with European and international importers of fruits and vegetables.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>
                            <h4>mission</h4>
                            <p className="mb-0">Our mission is to deliver premium products, build long-term partnerships, and
                                become a trusted supplier for our clients. We welcome our customers to visit our
                                farms at any time to explore potential collaborations.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Services End */}

  </>
}
